import { CLF_POPUP_CANCEL_CLICKED, CLF_POPUP_VISBILITY_EVENT } from "../../local_modules/vessel-clf-popup/src/vessel-wr-clf-popup";
import { WR_UPDATE_POPUP_VISBILITY_EVENT } from "../../local_modules/vessel-wr-update-popup/src/vessel-wr-update-popup";
import { VesselClfPopupNotification } from "../services/types/vessel-notifications-services.types";
import { VesselNotificationsService } from "../services/vessel-notifications-service";
import { VesselClfPopupModelBase } from "./vessel-clf-popup-model";

export class VesselClfPopupModelImpl extends VesselClfPopupModelBase {
  constructor() {
    super();
  }

  private _scheduleId: string | null = null;
  private _departureTerminalCode: string | null = null;
  private _arrivalTerminalCode: string | null = null;
  private _planId: number | null = null;
  private _eta?: string | number = "";
  private _etd?: string | number = "";
  private _type: string | null = null;

  async createVesselClfPopupNotification({reason, comment, correlationId}: VesselClfPopupNotification, type: string) {
    await VesselNotificationsService.createClfPopupNotification(this._scheduleId ?? '',this._departureTerminalCode ?? '', this._arrivalTerminalCode ?? '', this._planId ?? 0, {reason, comment, correlationId},this._eta ?? "", this._etd ?? "", type);
  }

  setPopupVisibility( type: string, scheduleId: string, departureTerminal: string, arrivalTerminal: string, plansId: number, eta?: string|number, etd?: string|number, correlationId?: string) {
    this._scheduleId = scheduleId;
    this._departureTerminalCode = departureTerminal;
    this._arrivalTerminalCode = arrivalTerminal;
    this._planId = plansId;
    this._eta = eta;
    this._etd = etd; 
    this._type = type;

    this.dispatchEvent(new CustomEvent(CLF_POPUP_VISBILITY_EVENT, {detail: { show: true, plansId, scheduleId: this._scheduleId, correlationId: correlationId}}));
  }

  onCancelClicked() {
    this.dispatchEvent(new CustomEvent(CLF_POPUP_CANCEL_CLICKED));
  }

  setWRUpdatePopupVisibility(scheduleId: string) {
    if(!scheduleId) {
      console.error('scheduleId is required to show WR Update Popup');
      return;
    }
    this.dispatchEvent(new CustomEvent(WR_UPDATE_POPUP_VISBILITY_EVENT, {detail: { show: true, scheduleId }}));
  }
}
